import React from "react";
import IBackorderLimitExceededItem from "@models/DTO/IBackorderLimitExceededItem";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import OwButton from "@components/shared/OwButton/OwButton";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import UIService from "@services/UIService";
import "./BackorderLimitExceededModal.scss";

type Props = {
    items: IBackorderLimitExceededItem[];
    message: string;
    closeFn: () => void;
};

export const BackorderLimitExceededModal = (props: Props) => {
    return (
        <div className="BackorderLimitExceededModal">
            <div className="modal-header">
                <OwTitle title="backorder_limit_exceeded" tag="h5" />
            </div>
            <div className="modal-body">
                <p className="text-danger mb-3">{props.message}</p>
                <table className={"table table-sm " + (UIService.isMainViewLight() ? "" : "table-dark")}>
                    <thead>
                        <tr>
                            <th>
                                <OwLabel title="sku" noBottomMargin={true} />
                            </th>
                            <th>
                                <OwLabel title="name" noBottomMargin={true} />
                            </th>
                            <th>
                                <OwLabel title="qty_on_hand" noBottomMargin={true} />
                            </th>
                            <th>
                                <OwLabel title="backorder_limit" noBottomMargin={true} />
                            </th>
                            <th>
                                <OwLabel title="currently_backordered" noBottomMargin={true} />
                            </th>
                            <th>
                                <OwLabel title="backorder_remaining" noBottomMargin={true} />
                            </th>
                            <th>
                                <OwLabel title="ordered_qty" noBottomMargin={true} />
                            </th>
                            <th>
                                <OwLabel title="max_order_qty" noBottomMargin={true} />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.items.map((item) => (
                            <tr key={item.sku}>
                                <td>{item.sku}</td>
                                <td>{item.name}</td>
                                <td>{item.qtyOnHand}</td>
                                <td>{item.backorderLimit}</td>
                                <td>{item.currentBackordered}</td>
                                <td>{item.backorderLimitRemaining}</td>
                                <td className="text-danger fw-bold">{item.orderedQty}</td>
                                <td className="text-warning fw-bold">{item.maxOrderQty}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="modal-footer">
                <OwButton title="close" fn={props.closeFn} className="btn-secondary" />
            </div>
        </div>
    );
};
